import * as yup from 'yup';
import type { FormBadgeListProps } from '@gov-nx/ui/types';

interface FieldProps<Value extends Record<string, boolean>> {
	name: string;
	options: { name: keyof Value; label: string }[];
	defaultValues: Value;
}

export type BadgeListDefinition<
	Value extends Record<string, boolean> = Record<string, boolean>,
> = {
	schema: yup.ObjectSchema<Record<keyof Value, yup.BooleanSchema>>;
	defaultValue: Value;
	field: FormBadgeListProps<keyof Value>;
};
export const getBadgeListDefinition = <Value extends Record<string, boolean>>(
	props: FieldProps<Value>
): BadgeListDefinition<Value> => {
	const shape = props.options.reduce(
		(all, current) => ({ ...all, [current.name]: yup.boolean() }),
		{} as Record<keyof Value, yup.BooleanSchema>
	);

	const schema = yup.object(shape) as yup.ObjectSchema<
		Record<keyof Value, yup.BooleanSchema>
	>;

	return {
		schema,
		defaultValue: props.defaultValues,
		field: {
			field: {
				name: props.name,
			},
			options: props.options,
		},
	};
};
